export default {
  loading: false,
  mgmt_stamps: [],
  mgmt_stamp: {},
  totalCount: 0,
};
